import catalog from "@/data/catalog.json";

export const SHOP_PRODUCTS = catalog.products;
export const SHOP_COLLECTIONS = catalog.collections;
export const SHOP_META = catalog.shop_meta;

const byUrl = new Map(SHOP_PRODUCTS.filter((p) => p.url_slug).map((p) => [p.url_slug, p]));
const bySlug = new Map(SHOP_PRODUCTS.map((p) => [p.slug, p]));
const byPath = new Map(SHOP_COLLECTIONS.map((c) => [c.path, c]));

export const productByUrlSlug = (s) => byUrl.get(s);
export const productBySlug = (s) => bySlug.get(s);
export const collectionByPath = (path) => byPath.get(path);
export const productsForCollection = (c) => c.product_slugs.map((s) => bySlug.get(s)).filter(Boolean);
export const cityCollectionForDirectory = (stateSlug, citySlug) =>
  SHOP_COLLECTIONS.find((c) => c.directory_path === `/run-clubs/${stateSlug}/${citySlug}`);
const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
export const TOP_COLLECTIONS = SHOP_COLLECTIONS.filter((c) => !c.city_slug && !c.is_state);
export const CITY_COLLECTIONS = SHOP_COLLECTIONS.filter((c) => c.city_slug);
export const STATE_COLLECTIONS = SHOP_COLLECTIONS.filter((c) => c.is_state);

export const CITY_STATE_GROUPS = (() => {
  const m = new Map();
  for (const c of CITY_COLLECTIONS) {
    if (!m.has(c.state)) m.set(c.state, { state: c.state, slug: c.state_slug || slugify(c.state || "more"), cities: [] });
    m.get(c.state).cities.push(c);
  }
  return [...m.values()].sort((a, b) => b.cities.length - a.cities.length || a.state.localeCompare(b.state));
})();
